import { classNames } from '@progress/kendo-react-common'
import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { ChevronDownIcon } from '@heroicons/react/solid'
import Translation from 'components/Translation'
import { useTenantContext } from 'context/TenantContext'
type UniversalCreateButtonProps = {
    handleUniversalButtonChange: (text: string) => void
}

export const UNIVERSAL_CREATE = {
    APPOINTMENT: 'APPOINTMENT',
    SALE: 'SALE',
    CLIENT: 'CLIENT',
    MEMBERSHIP: 'MEMBERSHIP',
    SERVICE: 'SERVICE',
    CLASS: 'CLASS',
    STAFF: 'STAFF',
    LOCATION: 'LOCATION',
}

export function UniversalCreateButton({
    handleUniversalButtonChange,
}: UniversalCreateButtonProps) {
    const { sidebar_items } = useTenantContext()

    const UNIVERSAL_OPTIONS = [
        // {
        //     id: 1,
        //     title: 'new_sale',
        //     value: UNIVERSAL_CREATE.SALE,
        //     icon: '/images/save_icon.svg',
        // },
        {
            id: 9,
            title: 'new_appointment',
            value: UNIVERSAL_CREATE.APPOINTMENT,
            icon: '/images/briefcase.svg',
            is_hidden: false,
        },
        {
            id: 7,
            title: 'new_class',
            value: UNIVERSAL_CREATE.CLASS,
            icon: '/images/class_icon.svg',
            is_hidden: false,
        },
        {
            id: 2,
            title: 'new_client',
            value: UNIVERSAL_CREATE.CLIENT,
            icon: '/images/client_icon.svg',
            is_hidden: sidebar_items.find(item => item.translation_key === 'clients')?.is_hidden == false ? false : true,
        },
        {
            id: 4,
            title: 'new_location',
            value: UNIVERSAL_CREATE.LOCATION,
            icon: '/images/location_icon.svg',
            is_hidden: sidebar_items.find(item => item.translation_key === 'locations')?.is_hidden == false ? false : true,
        },
        {
            id: 6,
            title: 'new_membership',
            value: UNIVERSAL_CREATE.MEMBERSHIP,
            icon: '/images/membership_icon.svg',
            is_hidden: sidebar_items.find(item => item.translation_key === 'memberships')?.is_hidden == false ? false : true,
        },
        {
            id: 8,
            title: 'new_sale',
            value: UNIVERSAL_CREATE.SALE,
            icon: '/images/dollar-sign.svg',
            is_hidden: sidebar_items.find(item => item.translation_key === 'point_of_sale')?.is_hidden == false ? false : true,
        },
        {
            id: 5,
            title: 'new_service',
            value: UNIVERSAL_CREATE.SERVICE,
            icon: '/images/service_icon.svg',
            is_hidden: sidebar_items.find(item => item.translation_key === 'services')?.is_hidden == false ? false : true,
        },
        {
            id: 3,
            title: 'new_staff',
            value: UNIVERSAL_CREATE.STAFF,
            icon: '/images/staff_icon.svg',
            is_hidden: sidebar_items.find(item => item.translation_key === 'staff')?.is_hidden == false ? false : true,
        },
    ]
    return (
        <div>
            <Menu
                as="div"
                className={classNames(
                    'relative inline-block text-left',
                    ' h-full bg-custom-dark-cyan-blue',
                    'border-custom-dark-cyan-blue brdr-radius-custom',
                    'text-white'
                )}
            >
                    <Menu.Button className="inline-flex justify-around  text-sm aot-primary-btn bg-opacity-20 hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 items-center ">
                        {/* {addIcon()}{' '} */}
                        <i className="feather-plus mr-2"></i>
                        <p className=" font-medium">
                            <Translation content_key="new" />
                        </p>
                        <ChevronDownIcon
                            className="w-5 h-5 ml-1 mr-1"
                            aria-hidden="true"
                        />
                    </Menu.Button>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu.Items
                        className="z-20 absolute right-0 w-56 mt-2 origin-top-right bg-gray-100 divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                        style={{ fontSize: '16px', fontWeight: 'normal' }}
                    >
                        <div className="px-1 py-1">
                            {UNIVERSAL_OPTIONS.filter(option => !option.is_hidden).map((option) => (
                                <Menu.Item key={option.id}>
                                    {({ active, disabled }) => (
                                        <button
                                            className={classNames(
                                                active && 'bg-primary-lighter',
                                                'group flex rounded-md text-gray-900 items-center w-full px-2 py-2 text-sm',
                                            )}
                                            onClick={() =>
                                                handleUniversalButtonChange(
                                                    option.value
                                                )
                                            }
                                        >
                                            <img
                                                className="w-5 h-5 mr-4"
                                                src={option.icon}
                                                alt={option.title}
                                            />

                                            <Translation
                                                content_key={option.title}
                                            />
                                        </button>
                                    )}
                                </Menu.Item>
                            ))}
                        </div>
                    </Menu.Items>
                </Transition>
            </Menu>
        </div>
    )
}

export default UniversalCreateButton

const addIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
    >
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
        />
    </svg>
)
